import { ThemeProvider } from "@mui/material/styles";
import { LabDataEntryPage } from "./DataEntryPage";
import theme from "./theme/theme";

const LabDataEntry = () => {
  return (
    <>
      <div id={"dummy"} style={{ height: "0", width: "0" }}></div>
      <ThemeProvider theme={theme}>
        <LabDataEntryPage />
      </ThemeProvider>
    </>
  );
};

export default LabDataEntry;
